import { dayjs } from '@convenia/utils'
import { validPhrase } from '@convenia/employee-organisms/SystemFields/helpers'

export default () => ({
  livesInBrazil: {
    type: 'radio',
    label: 'Reside no Brasil?',
    displayBy: 'label',
    trackBy: 'value',
    options: [
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ]
  },

  visaId: {
    type: 'select',
    label: 'Tipo de visto',
    placeholder: 'Tipo de visto',
    options: [],
    optionsSrc: 'visaTypes',
    displayBy: 'name',
    trackBy: 'id',
    value: '',
    hide: (formData) => !formData?.livesInBrazil
  },

  arrivalDate: {
    type: 'date',
    label: 'Data de chegada',
    placeholder: 'Data de chegada',
    enableInput: true,
    value: '',
    validation: {
      custom: (_, input) => dayjs(input).isValid()
    },
    validationMsg: 'Data inválida.',
    emitPreValidation: true,
    hide: (formData) => !formData?.livesInBrazil
  },

  naturalizationDate: {
    type: 'date',
    label: 'Data de naturalização',
    placeholder: 'Data de naturalização',
    enableInput: true,
    value: '',
    validation: {
      custom: (_, input) => dayjs(input).isValid()
    },
    validationMsg: 'Data inválida.',
    emitPreValidation: true,
    hide: (formData) => !formData?.livesInBrazil
  },

  residenceTimeId: {
    type: 'radio',
    label: 'Tempo de residência no brasil',
    value: '',
    displayBy: 'name',
    trackBy: 'id',
    options: [],
    optionsSrc: 'residenceTimes',
    hide: (formData) => !formData?.livesInBrazil
  },

  entryConditionId: {
    type: 'select',
    label: 'Condição de ingresso',
    placeholder: 'Condição de ingresso',
    displayBy: 'name',
    trackBy: 'id',
    value: '',
    options: [],
    optionsSrc: 'entryConditions',
    hide: (formData) => !formData?.livesInBrazil
  },

  countryId: {
    type: 'select',
    label: 'País de origem',
    placeholder: 'País de origem',
    options: [],
    optionsSrc: 'countries',
    displayBy: 'name',
    trackBy: 'id',
    value: ''
  },

  zipCodeForeign: {
    type: 'text',
    label: 'CEP no exterior',
    placeholder: 'Insira o CEP',
    validation: '',
    validationMsg: 'Informe um CEP válido.',
    value: '',
    maxLength: 67,
    hide: (formData) => formData?.livesInBrazil
  },

  foreignAddress: {
    type: 'text',
    label: 'Endereço no exterior',
    placeholder: 'Insira o endereço',
    value: '',
    maxLength: 67,
    validation: {
      custom: (_, value) => validPhrase(value)
    },
    hide: (formData) => formData?.livesInBrazil
  },

  addressDescription: {
    type: 'select',
    label: 'Descrição do logradouro',
    placeholder: 'Insira a descrição do logradouro',
    options: [],
    optionsSrc: 'addressDescription',
    displayBy: 'name',
    trackBy: 'id',
    value: '',
    maxLength: 67,
    hide: (formData) => formData?.livesInBrazil
  },

  number: {
    type: 'text',
    label: 'Número no exterior',
    placeholder: 'Insira o número',
    value: '',
    validation: '',
    maxLength: 7,
    hide: (formData) => formData?.livesInBrazil
  },

  complement: {
    type: 'text',
    label: 'Complemento no exterior',
    placeholder: 'Insira o complemento',
    value: '',
    maxLength: 67,
    validation: {
      custom: (_, value) => validPhrase(value)
    },
    hide: (formData) => formData?.livesInBrazil
  },

  district: {
    type: 'text',
    label: 'Bairro/Distrito no exterior',
    placeholder: 'Insira o bairro',
    value: '',
    maxLength: 67,
    validation: {
      custom: (_, value) => validPhrase(value)
    },
    hide: (formData) => formData?.livesInBrazil
  },

  city: {
    type: 'text',
    label: 'Cidade no exterior',
    placeholder: 'Insira a cidade',
    value: '',
    maxLength: 67,
    validation: {
      custom: (_, value) => validPhrase(value)
    },
    hide: (formData) => formData?.livesInBrazil
  },

  marriedToBrazilian: {
    type: 'radio',
    label: 'Casado(a) com brasileiro(a)?',
    value: false,
    displayBy: 'label',
    trackBy: 'value',
    options: [
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ]
  },

  hasBrazilianOffspring: {
    type: 'radio',
    label: 'Tem filho(a) brasileiro(a)?',
    value: false,
    displayBy: 'label',
    trackBy: 'value',
    options: [
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ]
  }
})
